import { Maybe, ParsedPreset } from '@aibees/shared/definition';
import { QueryOptions, useBaseQuery } from '@aibees/shared/http';
import { jsonParse } from '@aibees/shared/utils';
import { SHAREABLE_PRESET_API_PREFIX } from './constants';

/**
 * Reads a single shareable preset by id from the `gm` preset endpoint
 * (e.g. `/api/elephant-management/gm/presets/:id`). Shareable presets are not
 * served by the `um` routes used by `useReadPresetApi`, so this hook targets the
 * dedicated address and is workspace-agnostic (cross-workspace by design).
 */
export function useReadShareablePresetApi<T>(
  id: Maybe<string>,
  options?: QueryOptions
) {
  return useBaseQuery<any, ParsedPreset<T>, ParsedPreset<T>>(
    [useReadShareablePresetApi.name, id],
    {
      url: `${SHAREABLE_PRESET_API_PREFIX}/${id}`,
    },
    {
      ...options,
      select: (data) => {
        data.value = jsonParse(data.value) as T;
        return data;
      },
    }
  );
}
